import { render, staticRenderFns } from "./ElderlyGov.vue?vue&type=template&id=7ff9ffed&scoped=true&"
import script from "./ElderlyGov.vue?vue&type=script&lang=js&"
export * from "./ElderlyGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff9ffed",
  null
  
)

export default component.exports